import $ from 'jquery'

$(() => {
	const collection = window.location.pathname.split('/').pop(),
				currentURL = window.location.origin,
				shopByInputs = document.querySelectorAll('.collection__shop-by__input'),
				viewByEl  = document.querySelector('.collection__view-by'),
        categories = ['bracelet-category', 'earring-category', 'necklace-category', 'ring-category']

	if(categories.includes(document.querySelector('body').id)) {
    viewByEl.classList.add('visible')
    document.querySelectorAll(`.collection-items`).forEach(el => el.classList.remove('visible'))
    document.querySelectorAll(`.category-items`).forEach(el => el.classList.add('visible'))

    document.querySelectorAll('#shopBy .input-label-group').forEach(el => el.classList.remove('active'))
    document.querySelector('#shopBy_category').parentElement.classList.add('active')
  } else if (document.querySelector('body').id === 'products') {

  } else {
    viewByEl.classList.add('visible')
    document.querySelectorAll(`.category-items`).forEach(el => el.classList.remove('visible'))
    document.querySelectorAll(`.collection-items`).forEach(el => el.classList.add('visible'))

    document.querySelectorAll('#shopBy .input-label-group').forEach(el => el.classList.remove('active'))
    document.querySelector('#shopBy_collection').parentElement.classList.add('active')
  }


	$('#shopBy .input-label-group, #viewBy .input-label-group').on('click', (e) => {
		if($(e.target).attr('name') == 'shop-by') {
			$('#shopBy .input-label-group').removeClass('active')
			$(e.currentTarget).addClass('active')
      var str = $(e.target).attr('id').replace('shopBy_', '')
			switch($(e.target).attr('id')) {
				case 'shopBy_all':
					window.location.replace(`${currentURL}/collections/all`)
					break
				case 'shopBy_category':
          viewByEl.classList.add('visible')
          document.querySelectorAll(`.collection-items`).forEach(el => el.classList.remove('visible'))
          document.querySelectorAll(`.${str}-items`).forEach(el => el.classList.add('visible'))
          break
				case 'shopBy_collection':
          viewByEl.classList.add('visible')
          document.querySelectorAll(`.category-items`).forEach(el => el.classList.remove('visible'))
          document.querySelectorAll(`.${str}-items`).forEach(el => el.classList.add('visible'))
          break
				default:
			}
		}
		else if ($(e.target).attr('name') == 'view-by') {
			$('#viewBy .input-label-group').removeClass('active')
			$(e.currentTarget).addClass('active')
		}
	})
})